module.exports = __webpack_public_path__ + "img/block_3.57df3f42.webp";